import { useEffect, useState } from "react";
import { toast } from "sonner";
import { MessageSquare } from "lucide-react";
import { api, errMsg, formatDate } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";

export const CommentsSection = ({ articleId }) => {
  const [comments, setComments] = useState([]);
  const [form, setForm] = useState({ name: "", email: "", content: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => { api.get(`/articles/${articleId}/comments`).then((r) => setComments(r.data)).catch(() => {}); }, [articleId]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post(`/articles/${articleId}/comments`, form);
      toast.success("Merci ! Votre commentaire sera publié après modération.");
      setForm({ name: "", email: "", content: "" });
    } catch (err) { toast.error(errMsg(err)); } finally { setLoading(false); }
  };

  return (
    <section data-testid="article-comments-section" className="mt-12">
      <div className="section-title"><h2 className="flex items-center gap-2"><MessageSquare size={18} className="text-red-600" /> Commentaires ({comments.length})</h2></div>
      <div className="space-y-4 mb-8">
        {comments.length === 0 && <p className="text-sm text-zinc-500" data-testid="no-comments">Soyez le premier à réagir à cet article.</p>}
        {comments.map((c) => (
          <div key={c.id} data-testid={`comment-${c.id}`} className="bg-white border border-zinc-200 p-4">
            <div className="flex items-center gap-2 text-sm"><span className="w-8 h-8 rounded-full bg-[#111827] text-white flex items-center justify-center font-bold text-xs">{c.name[0]?.toUpperCase()}</span><span className="font-bold">{c.name}</span><span className="text-zinc-400 text-xs">· {formatDate(c.created_at)}</span></div>
            <p className="text-sm text-zinc-700 mt-2 whitespace-pre-line">{c.content}</p>
          </div>
        ))}
      </div>
      <form onSubmit={submit} className="bg-white border border-zinc-200 p-5 space-y-3" data-testid="comment-form">
        <h3 className="font-heading font-bold">Laisser un commentaire</h3>
        <div className="grid sm:grid-cols-2 gap-3">
          <Input data-testid="comment-name-input" required minLength={2} placeholder="Votre nom *" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
          <Input data-testid="comment-email-input" type="email" placeholder="E-mail (facultatif)" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
        </div>
        <Textarea data-testid="comment-content-input" required minLength={3} rows={4} placeholder="Votre commentaire *" value={form.content} onChange={(e) => setForm({ ...form, content: e.target.value })} />
        <Button data-testid="comment-form-submit-btn" disabled={loading} className="bg-red-600 hover:bg-red-700 rounded-none font-bold uppercase text-xs tracking-wider">{loading ? "Envoi…" : "Publier"}</Button>
      </form>
    </section>
  );
};
